// extracted by mini-css-extract-plugin
export default {"outer":"LeadingVisual-module__outer__AfDbwD4","inner":"LeadingVisual-module__inner__YWO7VWy"};